import { PanelbarStructure } from "../isPanelbarDetails";
import { Helper } from "../../util/helper";
import { Config } from "../../config/config";
import { StringKeyDictionary } from "../../../commonInterfaces";
import React from "react"
export default class AssignmentDetails extends React.Component<any, any> {
    private translations: StringKeyDictionary<string> = {};


    componentDidMount() {
        Helper.getTranslations(["Field.Einsatz.projnr", "Field.Einsatz.pindex", "Field.Adresse.adrnr", "Field.Einsatz.kennung", "Field.Einsatz.Bemerkung", "Field.Adresse.adrname", "Field.Einsatz.startist", "Field.Einsatz.endeist"])
            .then(result => {
                if (Helper.hasValue(result)) {
                    this.translations = result.Data;
                    this.setState({});
                }
            });
    }

    render() {
        const data = this.props.data;
        return (
            <PanelbarStructure label={`${data.Name || "-"} | ${data.Kennung || "-"}`} keyPropValue={data.ProjNr} iconName={"calendar-check"} url={"ResourcePlanning/Edit?projnr=" + encodeURIComponent(data.ProjNr) + "&pindex=" + + encodeURIComponent(data.PIndex)}>
                <table className="templateHoverTable">
                    <tbody>
                        <tr>
                            <td>
                                <span><a href={Config.baseUrl + "Address/Edit?id=" + encodeURIComponent(data.AdrNr)} target="_blank">{data.AdrNr}</a></span>
                            </td>
                        </tr>
                        {data.RessNr != null ?
                            (<tr>
                                <td>
                                    <span><a href={Config.baseUrl + "Resource/Edit?id=" + encodeURIComponent(data.RessNr)} target="_blank">{data.Name || data.RessNr}</a></span>
                                </td>
                            </tr>) : null}
                        <tr>
                            <td>
                                <span>{data.Bemerkung === null ? "-" : data.Bemerkung}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{data.AdrName}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{new Date(data.StartIst).toLocaleDateString(kendo.culture().name, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' })}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{new Date(data.EndeIst).toLocaleDateString(kendo.culture().name, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' })}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </PanelbarStructure>
        );
    }
}